import { render, staticRenderFns } from "./SyncCustomers.vue?vue&type=template&id=2ed96c52&scoped=true&"
import script from "./SyncCustomers.vue?vue&type=script&lang=js&"
export * from "./SyncCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed96c52",
  null
  
)

export default component.exports